import type { SVGProps } from 'react'
const SvgTrashIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="12"
    height="12"
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_31258_207481)">
      <path
        d="M2.25 3.5H3.08333H9.75"
        stroke="#464646"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.91668 3.50016V9.3335C8.91668 9.55451 8.82888 9.76647 8.6726 9.92275C8.51632 10.079 8.30436 10.1668 8.08334 10.1668H3.91668C3.69566 10.1668 3.4837 10.079 3.32742 9.92275C3.17114 9.76647 3.08334 9.55451 3.08334 9.3335V3.50016M4.33334 3.50016V2.66683C4.33334 2.44582 4.42114 2.23385 4.57742 2.07757C4.7337 1.92129 4.94566 1.8335 5.16668 1.8335H6.83334C7.05436 1.8335 7.26632 1.92129 7.4226 2.07757C7.57888 2.23385 7.66668 2.44582 7.66668 2.66683V3.50016"
        stroke="#464646"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.16666 5.5835V8.0835"
        stroke="#464646"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.83334 5.5835V8.0835"
        stroke="#464646"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_31258_207481">
        <rect width="10" height="10" fill="white" transform="translate(1 1)" />
      </clipPath>
    </defs>
  </svg>
)
export default SvgTrashIcon
